/* eslint-disable */

/** The presentation style to use when drawing a card */
export enum CardPresentationStyle {
  PSEUDO_3D = "PSEUDO_3D",
  TRUE_3D = "TRUE_3D",
  LEGACY_2D = "LEGACY_2D",
}
